


















































































import { Component, Vue } from 'vue-property-decorator';
import services from '@/services';
import * as amplitude from 'amplitude-js';
import {
  CatalogItemFullDTO, SearchParamsDTO, ThingsForLookRequestDTOStyleEnum,
  ThingsForLookRequestDTOPricesEnum, ThingsForLookRequestDTOSeasonsEnum,
  FilterDTO,
} from '@/api';
import { clientsModule, looksModule } from '@/store';
import EditingLayout from '@/layouts/EditingLayout.vue';
import LookDynamicCard from '@/components/looks/LookDynamicCard.vue';
import IconArrowLeft from '@/assets/icons/arrow-left.svg';
import IconAddComment from '@/assets/icons/add-comment.svg';
import IconFilter from '@/assets/icons/filters.svg';
import { getAssetUrl, throwError } from '@/utils';
import AiParams from '@/components/ai/AiParams.vue';

type Param = { type: string; id: string };

@Component({
  name: 'ai-things-page',
  components: {
    EditingLayout, LookDynamicCard, IconArrowLeft, IconAddComment, IconFilter, AiParams,
  },
})
export default class AiThingsPage extends Vue {
  things: CatalogItemFullDTO[] = [];

  openParams = false;

  searchParams: null | SearchParamsDTO = null;

  loading = false;

  categories: FilterDTO[]=[];

  async created() {
    services.aiApi().aiEndpointSearchParams()
      .then((data) => {
        this.searchParams = data.data;
      })
      .catch((e) => {
        throwError('Ошибка загрузка параметров поиска')(e);
      });
    await this.fetchCategories();
    if (!this.lookCategory && this.categories[0]?.id != null) {
      this.selectCategory(this.categories[0]?.id);
    }
    this.fetchThings();
    amplitude.getInstance().logEvent('Открыта страница вещей от аи');
  }

  get lookCategory() {
    return this.$route.query.category;
  }

  fetchCategories() {
    const getChildren = (filter: FilterDTO): FilterDTO[] => {
      const curr = { name: filter.name, id: filter.id, type: filter.type };
      if (filter.children) {
        const children = filter.children.flatMap(child => getChildren(child));
        return [curr, ...children];
      }
      return [curr];
    };
    return services.catalogService().catalogEndpointGetFilterNames('CATEGORY')
      .then(({ data }) => data.map(cat => getChildren(cat)))
      .then(data => data.flat())
      .then(data => data.reduce<FilterDTO[]>((acc, curr) => (acc
        .find(f => f.id === curr.id) ? acc : acc.concat(curr)), []))
      .then((data) => {
        this.categories = data;
      });
  }

  fetchThings() {
    // eslint-disable-next-line no-nested-ternary
    const toArray = (value?: string | (string | null)[]) => (Array.isArray(value)
      ? value
      : (value ? [value] : undefined));

    this.loading = true;

    if (this.$route.params.lookId) {
      services.aiApi().aiEndpointFindThingsForLook({
        lookId: Number(this.$route.params.lookId),
        categoryIds: [Number(this.$route.query.category)],
        style: toArray(this.$route.query.styles) as Array<ThingsForLookRequestDTOStyleEnum>,
        sizes: toArray(this.$route.query.sizes) as Array<string>,
        prices: toArray(this.$route.query.prices) as Array<ThingsForLookRequestDTOPricesEnum>,
        seasons: toArray(this.$route.query.seasons) as Array<ThingsForLookRequestDTOSeasonsEnum>,
      })
        .then((data) => {
          this.things = data.data;
        })
        .catch((e) => {
          throwError('Ошибка загрузка параметров поиска')(e);
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      services.aiApi().aiEndpointSuggestCatalogThings(
        [Number(this.$route.query.category)],
        toArray(this.$route.query.styles) as Array<ThingsForLookRequestDTOStyleEnum>,
        toArray(this.$route.query.sizes) as Array<string>,
        toArray(this.$route.query.prices) as Array<ThingsForLookRequestDTOPricesEnum>,
        toArray(this.$route.query.seasons) as Array<ThingsForLookRequestDTOSeasonsEnum>,
      )
        .then((data) => {
          this.things = data.data;
        })
        .catch((e) => {
          throwError('Ошибка загрузка параметров поиска')(e);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }

  get aiParams() {
    if (this.searchParams) {
      return [{
        name: 'Стиль',
        type: 'style',
        options: this.searchParams.styles || [],
      }, {
        name: 'Размер',
        type: 'sizes',
        options: this.searchParams.sizes || [],
      }, {
        name: 'Ценовой диапазон',
        type: 'prices',
        options: this.searchParams.prices || [],
      }, {
        name: 'Погода',
        type: 'seasons',
        options: this.searchParams.seasons || [],
      }];
    }
    return [];
  }

  get params() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { selected, category, ...params } = this.$route.query;
    return Object.entries(params).flatMap((param) => {
      const [type, ids] = param;
      if (ids) {
        return (Array.isArray(ids) ? ids : [ids])
          .reduce<Param[]>((arr, id) => (id ? arr.concat({ type, id }) : arr), []);
      }
      return [];
    });
  }

  get selected() {
    return Number(this.$route.query.selected);
  }

  get selectedThing() {
    return this.things.find(item => item.id === this.selected);
  }

  get count() {
    return this.looks.length;
  }

  get looks() {
    return looksModule.groupedThingsByLook;
  }

  get options() {
    return (this.$route?.meta?.options || []);
  }

  get client() {
    return clientsModule.model;
  }

  setSelected(id: number) {
    this.$router.push({ query: { selected: String(id) } });
  }

  setParams(params: Param[]) {
    const query = params.reduce<Record<string, string[]>>((obj, param) => ({
      ...obj,
      [param.type]: obj[param.type] ? obj[param.type].concat(param.id) : [param.id],
    }), {});
    const { selected } = this.$route.query;
    this.$router.push({ query: { ...query, selected } });
  }

  getTitle(param: Param) {
    const category = this.aiParams.find(c => c.type === param.type);
    const option = category?.options.find(o => o.id === param.id);
    return option ? option.name : 'Error';
  }

  addLookToSandbox() {
    if (this.selectedThing && this.selectedThing.id != null) {
      // services.aiApi().aiEndpointAddLookToSandbox(this.selectedThing.id);
    }
  }

  goSandbox(item: CatalogItemFullDTO) {
    const price = item.prices ? item.prices[0] : undefined;
    if (this.client?.id != null && item && item.id != null && price && price.id != null) {
      services.sandboxApi().sandboxEndpointAddItem(this.client.id, item.id, price.id)
        .then(() => {
          this.$notify({ type: 'success', title: 'Товар добавлен', message: 'Товар добавлен в песочницу' });
        });
    }
  }

  selectCategory(id: string) {
    this.$router.push({ query: { category: String(id) } });
    this.fetchThings();
  }

  back() {
    this.$router.push({ name: this.options.back });
  }

  getImage(item: CatalogItemFullDTO) {
    return item.pictures && item.pictures.length && item.pictures[0].name
      ? getAssetUrl(item.pictures[0].name)
      : null;
  }
}

